// Source: https://namen.taalunie.org/
// Source: http://www.unicode.org/Public/cldr/41/core.zip/common/main/nl.xml
// Used the first source except where the second was more complete / descriptive.
export const dutchCountryNames: Record<string, string> = {
  AF: "Afghanistan",
  AX: "Åland",
  AL: "Albanië",
  DZ: "Algerije",
  AS: "Amerikaans-Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua en Barbuda",
  AR: "Argentinië",
  AM: "Armenië",
  AW: "Aruba",
  AU: "Australië",
  AT: "Oostenrijk",
  AZ: "Azerbeidzjan",
  BS: "Bahama's",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "België",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Caribisch-Nederland",
  BA: "Bosnië en Herzegovina",
  BW: "Botswana",
  BV: "Bouveteiland",
  BR: "Brazilië",
  IO: "Brits Indische Oceaanterritorium",
  BN: "Brunei",
  BG: "Bulgarije",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Kaapverdië",
  KH: "Cambodja",
  CM: "Kameroen",
  CA: "Canada",
  KY: "Kaaimaneilanden",
  CF: "Centraal-Afrikaanse Republiek",
  TD: "Tsjaad",
  CL: "Chili",
  CN: "China",
  CX: "Christmaseiland",
  CC: "Cocoseilanden",
  CO: "Colombia",
  KM: "Comoren",
  CD: "Congo-Kinshasa",
  CG: "Congo-Brazzaville",
  CK: "Cookeilanden",
  CR: "Costa Rica",
  HR: "Kroatië",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Tsjechië",
  DK: "Denemarken",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominicaanse Republiek",
  EC: "Ecuador",
  EG: "Egypte",
  SV: "El Salvador",
  GQ: "Equatoriaal-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  SZ: "Swaziland",
  ET: "Ethiopië",
  FK: "Falklandeilanden (Islas Malvinas)",
  FO: "Faeröer",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrijk",
  GF: "Frans-Guyana",
  PF: "Frans-Polynesië",
  TF: "Franse Zuidelijke Gebieden - Kerguelen",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgië",
  DE: "Duitsland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griekenland",
  GL: "Groenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinee",
  GW: "Guinee-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Heard en McDonaldeilanden",
  VA: "Vaticaanstad",
  HN: "Honduras",
  HK: "Hongkong",
  HU: "Hongarije",
  IS: "IJsland",
  IN: "India",
  ID: "Indonesië",
  IR: "Iran",
  IQ: "Irak",
  IE: "Ierland",
  IM: "Isle of Man",
  IL: "Israël",
  IT: "Italië",
  CI: "Ivoorkust",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordanië",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Noord-Korea",
  KR: "Zuid-Korea",
  KW: "Koeweit",
  KG: "Kirgizië",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libië",
  LI: "Liechtenstein",
  LT: "Litouwen",
  LU: "Luxemburg",
  MO: "Macau",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Maleisië",
  MV: "Malediven",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalleilanden",
  MQ: "Martinique",
  MR: "Mauritanië",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesië",
  MD: "Moldavië",
  MC: "Monaco",
  MN: "Mongolië",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar (Birma)",
  NA: "Namibië",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Nederland",
  NC: "Nieuw-Caledonië",
  NZ: "Nieuw-Zeeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk",
  MK: "Noord-Macedonië",
  MP: "Noordelijke Marianen",
  NO: "Noorwegen",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papoea-Nieuw-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipijnen",
  PN: "Pitcairneilanden",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roemenië",
  RU: "Rusland",
  RW: "Rwanda",
  BL: "Saint-Barthélemy",
  SH: "Sint-Helena, Ascension en Tristan da Cunha",
  KN: "Saint Kitts en Nevis",
  LC: "Saint Lucia",
  MF: "Sint-Maarten (Frankrijk)",
  PM: "Saint-Pierre en Miquelon",
  VC: "Saint Vincent en de Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tomé en Principe",
  SA: "Saoedi-Arabië",
  SN: "Senegal",
  RS: "Servië",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint-Maarten (Nederland)",
  SK: "Slowakije",
  SI: "Slovenië",
  SB: "Salomonseilanden",
  SO: "Somalië",
  ZA: "Zuid-Afrika",
  GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
  SS: "Zuid-Soedan",
  ES: "Spanje",
  LK: "Sri Lanka",
  SD: "Soedan",
  SR: "Suriname",
  SJ: "Spitsbergen en Jan Mayen",
  SE: "Zweden",
  CH: "Zwitserland",
  SY: "Syrië",
  TW: "Taiwan",
  TJ: "Tadzjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Oost-Timor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad en Tobago",
  TN: "Tunesië",
  TR: "Turkije",
  TM: "Turkmenistan",
  TC: "Turks- en Caicoseilanden",
  TV: "Tuvalu",
  UG: "Oeganda",
  UA: "Oekraïne",
  AE: "Verenigde Arabische Emiraten",
  GB: "Verenigd Koninkrijk",
  UM: "Amerikaanse Kleinere Afgelegen Eilanden",
  US: "Verenigde Staten",
  UY: "Uruguay",
  UZ: "Oezbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Britse Maagdeneilanden",
  VI: "Amerikaanse Maagdeneilanden",
  WF: "Wallis en Futuna",
  EH: "Westelijke Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AN: "Nederlandse Antillen",
  GZ: "Gazastrook",
  XK: "Kosovo",
};
